export enum PublicLabelSettings {
	PUBLIC_API_URL = 'PUBLIC_API_URL',
	RECORDING_ENABLED_FOR_ALL_USERS = 'RECORDING_ENABLED_FOR_ALL_USERS',
	JS_INJECTION = 'JS_INJECTION',
	GAMIFICATION_UI_MAIN = 'GAMIFICATION_UI_MAIN',
	GAMIFICATION_UI_WIDGET = 'GAMIFICATION_UI_WIDGET',
	GAMIFICATION_UI_MINI_GAME = 'GAMIFICATION_UI_MINI_GAME',
	GAMIFICATION_UI_SETTINGS = 'GAMIFICATION_UI_SETTINGS',
	GAMIFICATION_UI_MAIN_TEST = 'GAMIFICATION_UI_MAIN_TEST',
	GAMIFICATION_UI_WIDGET_TEST = 'GAMIFICATION_UI_WIDGET_TEST',
	GAMIFICATION_UI_SETTINGS_TEST = 'GAMIFICATION_UI_SETTINGS_TEST',
	FRONT_END_ALLOWED_LANGUAGES = 'FRONT_END_ALLOWED_LANGUAGES',
	FRONT_END_ALLOW_DOMAINS = 'FRONT_END_ALLOW_DOMAINS',
	DELAY_ENGAGEMENT_EXECUTION_ON_LOGIN_MS = 'DELAY_ENGAGEMENT_EXECUTION_ON_LOGIN_MS',
	SHADOW_LABEL_PUBLIC_KEY = 'SHADOW_LABEL_PUBLIC_KEY',
	DYNAMIC_IMAGE_DOMAIN = 'DYNAMIC_IMAGE_DOMAIN',

	GAMIFICATION_LEVELS_LOGIC2 = 'GAMIFICATION_LEVELS_LOGIC2',
	GAMIFICATION_LEVELS_LOGIC3 = 'GAMIFICATION_LEVELS_LOGIC2',

	AVATAR_CUSTOM_IMAGE_MAX_ID = 'AVATAR_CUSTOM_IMAGE_MAX_ID',
	AVATAR_CUSTOM_IMAGE_FOLDER = 'AVATAR_CUSTOM_IMAGE_FOLDER',

	GAMIFICATION_SHOW_POWERED_BY = 'GAMIFICATION_SHOW_POWERED_BY',
	_system_leader_board_mask_username = '_system_leader_board_mask_username',
	_system_gamification_mask_username = '_system_gamification_mask_username',

	INBOX_PUBLIC_CDN = 'INBOX_PUBLIC_CDN',
}
